export default __webpack_public_path__ + "static/media/TN.4442a13c.svg";